import { Badge } from '@optools/components/ui/badge';
import { cn } from '@optools/components/ui/utils';
import { startCase } from 'es-toolkit';
import { Cctv, Clapperboard, LucideProps, VideoOff } from 'lucide-react';
import { ForwardRefExoticComponent, RefAttributes } from 'react';

import { CopyrightStreamStatus } from './types';

export interface CopyrightStreamStatusBadgeProps {
  status: CopyrightStreamStatus;
}

const iconMap: Record<
  CopyrightStreamStatus,
  ForwardRefExoticComponent<Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>>
> = {
  notRecording: VideoOff,
  recorded: Clapperboard,
  recording: Cctv,
};

export function CopyrightStreamStatusBadge({ status }: CopyrightStreamStatusBadgeProps) {
  const Icon = iconMap[status];
  return (
    <Badge
      className={cn('gap-1', {
        'border-green-700 bg-green-500/10 text-green-700 hover:bg-green-500/10 dark:border-green-500 dark:text-green-500':
          status === 'recorded',
        'border-red-700 bg-red-500/10 text-red-700 hover:bg-red-500/10 dark:border-red-500 dark:text-red-500':
          status === 'notRecording',
        'border-yellow-700 bg-yellow-500/10 text-yellow-700 hover:bg-yellow-500/10 dark:text-yellow-500':
          status === 'recording',
      })}>
      {Icon && <Icon data-testid="copyright-status-icon" />}
      <span>{startCase(status)}</span>
    </Badge>
  );
}
